import { useCallback, useEffect, useState } from 'react'
import { useRecoilState } from 'recoil'
import { toastState } from '../components/helpers'

export default function useSnackbar() {
  const [snackPack, setSnackPack] = useState([])
  const [toast, setToast] = useRecoilState(toastState)

  useEffect(() => {
    if (snackPack.length && !toast.messageInfo) {
      setToast({
        ...snackPack[0],
        open: true,
      })
      setSnackPack((prev) => prev.slice(1))
    } else if (snackPack.length && toast.messageInfo && toast.open) {
      setToast({
        open: false,
      })
    }
  }, [setToast, snackPack, toast])

  const enqueueSnackbar = useCallback(
    (message, options) => {
      setSnackPack((prev) => [
        ...prev,
        { message, options, key: new Date().getTime() },
      ])
    },
    [setSnackPack]
  )

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }

    setToast({
      open: false,
    })
  }

  return {
    enqueueSnackbar,
    handleClose,
  }
}
